import React, { FC } from "react";
import { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import { ITheme, Tooltip } from "@evergis/ui";

import { PieChart, SpecialFilterStatBlock } from "../styled";

import { formatNumber } from "../../../utils/formatNumber";

export const FilledValues: FC<{ count?: number; totalCount?: number }> = ({ count, totalCount }) => {
  const { t } = useTranslation("table");
  const theme = useTheme() as ITheme;

  return (
    <Tooltip content={t("notNullValues")} arrow placement="top" delay={50}>
      {ref => (
        <SpecialFilterStatBlock style={{ position: "relative", top: "-2px" }} ref={ref}>
          <PieChart
            data={[
              {
                value: totalCount ? (count * 100) / totalCount : 0,
                color: theme.palette.iconDisabled,
              }, // not null, %
              {
                value: totalCount ? 100 - (count * 100) / totalCount : 0,
                color: theme.palette.element,
              }, // empty, %
            ]}
            outerRadius={0.55}
            width={14}
            height={14}
          />
          {`${formatNumber(+(totalCount ? (count * 100) / totalCount : 0).toFixed(2))}%`}
        </SpecialFilterStatBlock>
      )}
    </Tooltip>
  );
};
